__turbopack_context__.v({
  "root": "ReCaptchaLegal-module-scss-module__yFqMUa__root",
});
